var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import WidgetDisplay from "../widgetDisplay";
import { useTranslation } from "react-i18next";
import { useGetModuleBuilderLayoutListWidgetsQuery, useGetModuleListQuery, } from "@/store/api";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import store from "@/store";
import { useAppSelector, useAppDispatch } from "@/hooks/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faColumns3, faMagnifyingGlass, } from "@fortawesome/pro-solid-svg-icons";
import { useLayout, usePopup } from "@/hooks/layout";
import { Slot } from "@/utils/types/layout";
import { Input } from "@mui/joy";
import WidgetSelector from "../filters/selector";
import { setFieldState, setFrozenFieldState,
//setTotalFreezeRows,
 } from "@/store/fieldSlice";
import { setElementCountPerPage, setFiltersSelected, } from "@/store/filterSlice";
import { Pagination } from "@/components/dev/pagination";
import Massupdate from "./massupdate/massUpdate";
import { setSlots, setWidgetDisplay } from "@/store/layoutSlice";
import { setSortArgs } from "@/store/sortSlice";
import { LoaderImage } from "@/utils/loader";
import Switch from "@mui/joy/Switch";
import ViewManager from "./components/lists/viewManager";
import TuiGrid from "tui-grid";
import Grid from "@toast-ui/react-grid";
import "tui-grid/dist/tui-grid.css";
import { FieldViewType } from "@/components/fields/viewType";
import DisplayField from "@/components/fields/displayField";
import { Provider, shallowEqual } from "react-redux";
import { tableOptions } from ".";
import { createRoot } from "react-dom/client";
import { debounce } from "lodash";
import InboundEmail from "@/pages/administration/inBoundEmail";
import { translateLabel } from "@/utils/funcs";
function ModuleList(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var widget = _a.widget, onChange = _a.onChange;
    var module = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.module;
    var t = useTranslation(["common", module]).t;
    var tUnsafe = t;
    var _f = useAppSelector(function (state) { return ({
        filters_selected_state: state.filter,
        valueFieldState: state.field.fields_state_list,
        elementCountPerPage: state.filter.element_per_page,
        frozenColumns: state.field.frozen_fields,
        slots: state.layout.slots,
        widgetDisplay: state.layout.display,
    }); }, shallowEqual), filters_selected_state = _f.filters_selected_state, valueFieldState = _f.valueFieldState, elementCountPerPage = _f.elementCountPerPage, frozenColumns = _f.frozenColumns, slots = _f.slots, widgetDisplay = _f.widgetDisplay;
    var _g = useState(0), freezeColumns = _g[0], setFreezeColumns = _g[1];
    var popup = usePopup();
    var _h = useState([
        {
            name: "date_modified",
            direction: "descending",
        },
    ]), sortedParams = _h[0], setSortedParams = _h[1];
    var defaultCurrentPage = 0;
    var _j = useState(defaultCurrentPage), currentPage = _j[0], setCurrentPage = _j[1];
    var defaultElementPerPage = 50;
    var _k = useState(defaultElementPerPage), elementPerPage = _k[0], setElementPerPage = _k[1];
    var _l = useState([]), where = _l[0], setWhere = _l[1];
    useEffect(function () {
        if ((filters_selected_state === null || filters_selected_state === void 0 ? void 0 : filters_selected_state.selector_filters) &&
            filters_selected_state.selector_filters.length > 0) {
            setWhere(filters_selected_state === null || filters_selected_state === void 0 ? void 0 : filters_selected_state.selector_filters.map(function (item) { return item === null || item === void 0 ? void 0 : item.filters; }));
            setCurrentPage(0);
        }
        else {
            setWhere([]);
        }
    }, [filters_selected_state]);
    var _m = useState(false), isCheckedAll = _m[0], setIsCheckedAll = _m[1];
    // Event to change pagination
    var changePagination = function (e) {
        var newPage = e.selected;
        if (newPage !== currentPage) {
            setCurrentPage(e.selected);
        }
        // Remettre grid initial
        if (!isCheckedAll) {
            updateGridSelection();
        }
    };
    useEffect(function () {
        if (!isNaN(parseFloat(elementCountPerPage)) &&
            isFinite(elementCountPerPage)) {
            setElementPerPage(elementCountPerPage);
        }
        else if (elementCountPerPage === "infini") {
            setElementPerPage(undefined);
            setKey(function (prevKey) { return prevKey + 1; });
        }
    }, [elementCountPerPage]);
    /**
     * Mettre à jour le grid
     * @param newGrid
     * @param isChecked
     * @param rowChecked
     * @param rowIdChecked
     */
    var updateGridSelection = useCallback(function (isChecked, rowChecked, rowIdChecked) {
        if (isChecked === void 0) { isChecked = false; }
        if (rowChecked === void 0) { rowChecked = []; }
        if (rowIdChecked === void 0) { rowIdChecked = []; }
        setIsChecked(isChecked);
        setRowChecked(rowChecked);
        setRowIdChecked(rowIdChecked);
    }, []);
    // Module query
    var recordCount = useGetModuleListQuery({
        table: module,
        params: {
            where: where,
            count_only: true,
        },
    }).data;
    var _o = useGetModuleListQuery({
        table: module,
        params: {
            sorted: sortedParams,
            where: where,
            page: currentPage,
            pageSize: elementPerPage,
            count: false,
        },
    }), moduleList = _o.data, isLoading = _o.isLoading, refetch = _o.refetch;
    var _p = useState([]), record = _p[0], setRecord = _p[1];
    var _q = useState([]), tuiRecord = _q[0], setTuiRecord = _q[1];
    var _r = useState(0), resultCount = _r[0], setResultCount = _r[1];
    var _s = useState(0), totalResultCount = _s[0], setTotalResultCount = _s[1];
    var listableFields = ((_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.view_defs) || [];
    var field_defs = ((_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.field_defs) || [];
    var _t = useState(0), key = _t[0], setKey = _t[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var dataModule, data_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, (moduleList === null || moduleList === void 0 ? void 0 : moduleList.data)];
                    case 1:
                        dataModule = _a.sent();
                        return [4 /*yield*/, (recordCount === null || recordCount === void 0 ? void 0 : recordCount.data)];
                    case 2:
                        data_1 = _a.sent();
                        setRecord((dataModule === null || dataModule === void 0 ? void 0 : dataModule.records) || []);
                        setResultCount((dataModule === null || dataModule === void 0 ? void 0 : dataModule.count) || 0);
                        setTotalResultCount((data_1 === null || data_1 === void 0 ? void 0 : data_1.total_count) || 0);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Erreur lors de la récupération des données:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // N'exécuter qu'une seule fois au changement de page
        fetchData();
    }, [moduleList, recordCount, currentPage]);
    var fieldsAvailable = useMemo(function () { return valueFieldState === null || valueFieldState === void 0 ? void 0 : valueFieldState.filter(function (f) { return f.default; }); }, [valueFieldState]);
    useEffect(function () {
        var headerList = fieldsAvailable === null || fieldsAvailable === void 0 ? void 0 : fieldsAvailable.map(function (item) {
            return item.name;
        });
        var tuiRecordList = record === null || record === void 0 ? void 0 : record.map(function (item) {
            var temp2 = [];
            headerList === null || headerList === void 0 ? void 0 : headerList.forEach(function (field) {
                var _a;
                temp2 = __assign(__assign({}, temp2), (_a = {}, _a[field] = item[field] === undefined ? "" : item[field], _a));
            });
            return temp2;
        });
        setTuiRecord(tuiRecordList);
    }, [record, moduleList]);
    var dispatch = useAppDispatch();
    useEffect(function () {
        dispatch(setFieldState(listableFields));
        dispatch(setFiltersSelected(where));
        dispatch(setFrozenFieldState([]));
        //dispatch(setTotalFreezeRows([widget?.payload.module, 0]));
        dispatch(setElementCountPerPage(defaultElementPerPage));
        setCurrentPage(0);
    }, [module]);
    var headerCol = useMemo(function () {
        var columns = [];
        fieldsAvailable &&
            (fieldsAvailable === null || fieldsAvailable === void 0 ? void 0 : fieldsAvailable.map(function (item) {
                columns.push({
                    header: translateLabel(item.label, tUnsafe, module),
                    name: item.name,
                });
            }));
        return columns;
    }, [fieldsAvailable, t, module, field_defs]);
    var _u = useState(headerCol), columns = _u[0], setColumns = _u[1];
    useEffect(function () {
        valueFieldState && setColumns(headerCol);
    }, [valueFieldState]);
    var data = record || [];
    // Utiliser sort globale
    useEffect(function () {
        if (sortedParams) {
            dispatch(setSortArgs(sortedParams));
        }
    }, [sortedParams]);
    // rowMarkers : checkbox non multiple
    var _v = useState([]), rowChecked = _v[0], setRowChecked = _v[1];
    var _w = useState([]), rowIdChecked = _w[0], setRowIdChecked = _w[1];
    var filter = {
        id: "",
        type: "widget/selectorFilter",
        payload: {
            module: module || "Accounts",
            selectedFilters: (_e = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _e === void 0 ? void 0 : _e.selectedFilters,
        },
    };
    // Check selection rows
    var _x = useState(false), isChecked = _x[0], setIsChecked = _x[1];
    var _y = useState(String(t("app.LBL_MASSUPDATE_SELECTED"))), selectedDesc = _y[0], setSelectedDesc = _y[1];
    // Suppression enregistrement terminé
    var _z = useState(0), isDeleted = _z[0], setIsDeleted = _z[1];
    var _0 = useState(false), isLoad = _0[0], setIsLoad = _0[1];
    var handleFromMassupdate = useCallback(function (d) {
        setIsDeleted(d);
        setIsLoad(false);
        // Suppression en front
        var searchRecord, newsearchRecord, i, j, cur;
        searchRecord = Array.from(record);
        newsearchRecord = [];
        for (i = 0, j = searchRecord.length; i < j; i++) {
            cur = searchRecord[i];
            if (!rowChecked.includes(i)) {
                newsearchRecord.push(cur);
            }
        }
        var w = [
            {
                field: module,
                operator: "notin",
                value: rowIdChecked,
            },
        ];
        var s = [
            {
                name: "date_modified",
                direction: "ascending",
            },
        ];
        setWhere(w);
        setSortedParams(s);
        // Remettre grid initial
        updateGridSelection();
    }, [record, updateGridSelection]);
    useEffect(function () {
        var _a;
        if (rowChecked.length === totalResultCount) {
            var r = [];
            var j = void 0;
            for (j = 0; j < totalResultCount; j++) {
                r.push((_a = record[j]) === null || _a === void 0 ? void 0 : _a.id);
            }
            setRowIdChecked(r);
        }
    }, [record]);
    useEffect(function () {
        if (rowChecked.length === totalResultCount) {
            (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current) &&
                (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current) !== null &&
                (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.checkAll());
        }
        else {
            updateGridSelection();
        }
    }, [tuiRecord]);
    /**
     * Décocher toutes les lignes d'enregistrements
     */
    var tuiref = useRef(null);
    function handleUnCheckMassupdate() {
        updateGridSelection();
        (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current) && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.uncheckAll());
        setIsCheckedAll(false);
    }
    /**
     * Cocher toutes les lignes d'une page d'enregistrements
     */
    function handleCheckPageMassupdate() {
        var c = [];
        var r = [];
        var i;
        for (i = 0; i < data.length; i++) {
            c.push(i);
            r.push(data[i].id);
        }
        setIsCheckedAll(false);
        updateGridSelection(true, c, r);
        setSelectedDesc(String(t("app.LBL_MASSUPDATE_SELECTED")));
    }
    /**
     * Cocher toutes les lignes d'enregistrements
     */
    function handleCheckAllMassupdate() {
        dispatch(setElementCountPerPage("infini"));
        var c = [];
        var r = [];
        var j;
        for (j = 0; j < totalResultCount; j++) {
            c.push(j);
        }
        setIsCheckedAll(true);
        updateGridSelection(true, c, r);
        setSelectedDesc(String(t("app.LBL_MASSUPDATE_SELECTED")));
    }
    /**
     * Mettre un gif de loader pendant la suppression en masse
     * @param data
     */
    function isLoadDelete(data) {
        setIsLoad(true);
    }
    useEffect(function () {
        var frozen_columns_visible = frozenColumns === null || frozenColumns === void 0 ? void 0 : frozenColumns.filter(function (fc) { return fc.default === true; });
        setFreezeColumns(frozen_columns_visible === null || frozen_columns_visible === void 0 ? void 0 : frozen_columns_visible.length);
    }, [frozenColumns]);
    useEffect(function () {
        dispatch(setWidgetDisplay(true));
    }, []);
    /**
     * Tester si scroll existe, mettre à jour fusion de ligne
     * @param r
     */
    var initialConfigRef = useRef({
        filters: [],
        columns: listableFields,
        paginations: {
            paginationVisible: elementCountPerPage === "infini" && totalResultCount === 0
                ? false
                : true,
            totalResult: totalResultCount,
            elementPerPage: defaultElementPerPage,
            currentPage: defaultCurrentPage,
        },
        freezeColumns: [],
        //freezeRows: 0,
    });
    var _1 = useState(initialConfigRef.current), config = _1[0], setConfig = _1[1];
    useEffect(function () {
        var tempConfig = {
            filters: filters_selected_state.selector_filters,
            columns: valueFieldState,
            paginations: {
                paginationVisible: elementCountPerPage === "infini" ? false : true,
                totalResult: totalResultCount,
                elementPerPage: elementCountPerPage,
                currentPage: currentPage,
            },
            freezeColumns: frozenColumns,
            //freezeRows: frozenRowsValue,
        };
        if (!isSearchSimpleOn) {
            setConfig(tempConfig);
        }
    }, [
        valueFieldState,
        filters_selected_state.selector_filters,
        elementCountPerPage,
        totalResultCount,
        currentPage,
        frozenColumns,
        module,
    ]);
    var massUpdateFields = Object.values(field_defs).filter(function (field) {
        return (field.massupdate === true ||
            field.massupdate === "1" ||
            field.massupdate === 1);
    });
    // Refetch data after massupdate
    var _2 = useState(false), isMassUpdated = _2[0], setIsMassUpdated = _2[1];
    var handleMassupdateConfirm = function (d) {
        if (d === 1) {
            setIsMassUpdated(true);
        }
    };
    useEffect(function () {
        if (isMassUpdated) {
            refetch();
            setIsMassUpdated(false);
        }
    }, [isMassUpdated]);
    var _3 = useState(false), isFocusMode = _3[0], setIsFocusMode = _3[1];
    var handleModeScreen = function () {
        setIsFocusMode(function (prevMode) { return !prevMode; });
        if (isFocusMode) {
            normalMode();
        }
        else {
            focusMode();
        }
    };
    var updateSlots = function (enable) {
        var updatedSlots = Object.fromEntries(Object.entries(slots).map(function (_a) {
            var slot = _a[0], slotData = _a[1];
            if (slot === Slot.MAIN) {
                var updatedWidgets = slotData.widgets.map(function (widget) {
                    if (widget.type === "widget/module/list") {
                        return widget; // Keep unchanged
                    }
                    else {
                        return __assign(__assign({}, widget), { meta: __assign(__assign({}, widget.meta), { visible: enable }) });
                    }
                });
                return [slot, __assign(__assign({}, slotData), { widgets: updatedWidgets })];
            }
            else {
                return [slot, __assign(__assign({}, slotData), { enabled: enable })];
            }
        }));
        dispatch(setSlots(updatedSlots));
    };
    var normalMode = function () {
        updateSlots(true); // Enable slots
        tuiref.current && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setWidth(gridInitialWth));
    };
    var _4 = useState(1200), gridInitialWth = _4[0], setGridInitialWth = _4[1];
    var focusMode = function () {
        var elm = document.getElementById("grid");
        setGridInitialWth((elm === null || elm === void 0 ? void 0 : elm.offsetWidth) && (elm === null || elm === void 0 ? void 0 : elm.offsetWidth) - 10);
        (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current) &&
            (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setWidth(window.innerWidth - 60));
        updateSlots(false); // Disable slots
    };
    var _5 = useState(false), isSearchSimpleOn = _5[0], setIsSearchSimpleOn = _5[1];
    var handleSearchSimple = function (e) {
        setIsSearchSimpleOn(true);
        var value = e.target.value;
        var dataToSearch = [
            {
                rules: [
                    {
                        operator: "contains",
                        field: "name",
                        value: value,
                    },
                ],
            },
        ];
        setWhere(dataToSearch);
    };
    var inputRef = useRef(null);
    var handleClickOutside = function (event) {
        if (inputRef.current && !inputRef.current.contains(event.target)) {
            setIsSearchSimpleOn(false);
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var _6 = useGetModuleBuilderLayoutListWidgetsQuery({
        moduleName: module,
    }), list_widgetModule = _6.data, isLoadingWidgets = _6.isLoading;
    var _7 = useState([]), widgetModuleListFromLayout = _7[0], setWidgetModuleListFromLayout = _7[1];
    var getModuleListWidgets = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if ((_a = list_widgetModule === null || list_widgetModule === void 0 ? void 0 : list_widgetModule.data) === null || _a === void 0 ? void 0 : _a.listwidgets) {
                setWidgetModuleListFromLayout((_b = list_widgetModule === null || list_widgetModule === void 0 ? void 0 : list_widgetModule.data) === null || _b === void 0 ? void 0 : _b.listwidgets);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        getModuleListWidgets();
    }, [list_widgetModule]);
    /***************** TUI-GRID *******************/
    TuiGrid.applyTheme("default", tableOptions);
    var CellRendererClass = useCallback(function (props) {
        var el = document.createElement("div");
        var root = createRoot(el);
        var debouncedRender = debounce(function (props) {
            root.render(_jsx(Provider, __assign({ store: store }, { children: _jsx(DisplayField, { record: record[props.rowKey] || {}, moduleName: widget.payload.module, fieldName: props.columnInfo.name, className: "text-[var(--colors-text)]", viewType: FieldViewType.LIST, fieldLabel: props.columnInfo.header, fieldMetadata: field_defs[props.columnInfo.name], hideLabel: true }) })));
        }, 100);
        debouncedRender(props);
        return { getElement: function () { return el; }, render: debouncedRender };
    }, [record, field_defs, widget.payload.module]);
    var _8 = useState(columns), tuiCols = _8[0], setTuiCols = _8[1];
    useEffect(function () {
        var cols = columns.map(function (col) { return (__assign(__assign({}, col), { renderer: record.length ? CellRendererClass : undefined, sortable: true, sortingType: "desc" })); });
        setTuiCols(cols);
    }, [columns, record, CellRendererClass]);
    var rowHeaderRef = useRef(null);
    var simulateClick = useCallback(function () {
        var el = document.getElementById("all-checkbox");
        if (!el)
            return;
        if (isChecked && !el.checked)
            el.click();
        if (!isChecked && el.checked)
            el.click();
    }, [isChecked]);
    useEffect(function () {
        if ([0, elementCountPerPage, totalResultCount, record.length].includes(rowChecked.length)) {
            simulateClick();
        }
        else {
            setIsChecked(false);
        }
    }, [
        rowChecked,
        simulateClick,
        elementCountPerPage,
        totalResultCount,
        record.length,
    ]);
    var typePageOptions = elementCountPerPage === "infini" ? "scroll" : undefined;
    var perPage = elementCountPerPage === "infini" ? 30 : elementPerPage;
    var sort = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"sort\" class=\"svg-inline--fa fa-sort text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><path fill=\"currentColor\" d=\"M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z\"></path></svg>";
    var sortUp = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fad\" data-icon=\"sort-up\" class=\"svg-inline--fa fa-sort-up text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 320c0 8.3 3.3 16.5 9.4 22.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8C.8 311.7 0 315.9 0 320zm109.3 32l101.5 0L160 402.7 109.3 352z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z\"></path></g></svg>";
    var sortDown = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fad\" data-icon=\"sort-down\" class=\"svg-inline--fa fa-sort-down text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 192c0 4.1 .8 8.3 2.4 12.2c5 12 16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C3.3 175.5 0 183.7 0 192zm109.3-32L160 109.3 210.7 160l-101.5 0z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z\"></path></g></svg>";
    var GetHeaderClass = /** @class */ (function () {
        function GetHeaderClass(props) {
            var columnInfo = props.columnInfo || {};
            var colName = columnInfo.childNames[0] || "";
            var el = document.createElement("div");
            el.style.cssText =
                "display: flex;flex-direction: row;justify-content: space-between;padding-left: 8px;padding-right: 8px;";
            el.className = "column-header column-header-".concat(props.columnInfo.column);
            el.title = "".concat(columnInfo.header);
            var text = el.appendChild(document.createElement("span"));
            text.style.cssText =
                "overflow: hidden;text-overflow: ellipsis;white-space: nowrap; color: var(--colors-label);";
            text.textContent = "".concat(columnInfo.header);
            if (props.columnInfo.sortable) {
                var link_1 = el.appendChild(document.createElement("button"));
                link_1.className = "sort-icon";
                link_1.innerHTML = sort;
                link_1.addEventListener("click", function (event) {
                    // Remettre tous les boutons de tri à zero
                    var allSort = document.getElementsByClassName("sort-icon");
                    Array.from(allSort).forEach(function (l) { return (l.innerHTML = sort); });
                    var s = [
                        {
                            name: colName,
                            direction: columnInfo.sortOrder === "desc" ? "descending" : "ascending",
                        },
                    ];
                    link_1.innerHTML = columnInfo.sortOrder === "desc" ? sortDown : sortUp;
                    setSortedParams(s);
                    event.preventDefault();
                    event.stopPropagation();
                    if (columnInfo.sortOrder === "asc") {
                        columnInfo.sortOrder = "desc";
                    }
                    else {
                        columnInfo.sortOrder = "asc";
                    }
                });
            }
            this.el = el;
        }
        GetHeaderClass.prototype.getElement = function () {
            return this.el;
        };
        GetHeaderClass.prototype.render = function (props) { };
        return GetHeaderClass;
    }());
    var complexColumnPrefix = "complex_";
    useEffect(function () {
        // Complex columns
        var header = {
            complexColumns: [],
        };
        tuiCols.forEach(function (c) {
            // TODO: requete php à modifier pour le tri côté serveur pour les champs de type email et parent
            if (c.name !== "email1" && c.name !== "parent_name") {
                var columnName = "".concat(complexColumnPrefix).concat(c.name);
                var f = field_defs || {};
                var fd = f[c.name] || "";
                var isSortable = fd.sortable !== undefined ? fd.sortable : true;
                header.complexColumns.push({
                    header: c.header,
                    name: columnName,
                    childNames: [c.name],
                    headerAlign: "center",
                    headerVAlign: "middle",
                    headerRenderer: GetHeaderClass,
                    resizable: true,
                    hideChildHeaders: true,
                    sortOrder: "desc",
                    sortable: isSortable,
                });
            }
        });
        tuiref.current && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setHeader(header));
        tuiref.current &&
            (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setFrozenColumnCount(freezeColumns));
    }, [tuiref.current && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current), freezeColumns, tuiCols]);
    function loadEditing(loadValue) {
        setIsLoad(loadValue);
    }
    var layout = useLayout();
    useEffect(function () {
        layout.clearWidgets({
            slots: [
                Slot.PREVIEW_NORTH,
                Slot.PREVIEW_SOUTH,
                Slot.PREVIEW_EAST,
                Slot.PREVIEW_WEST,
                Slot.DRAWER_NORTH,
                Slot.DRAWER_SOUTH,
                Slot.DRAWER_EAST,
                Slot.DRAWER_WEST,
            ],
        });
    }, []);
    var gridRef = useRef(null);
    var _9 = useState(false), upGrid = _9[0], setUpGrid = _9[1];
    useEffect(function () {
        record.length > 0 && setUpGrid(true);
        if (gridRef.current) {
            var gridElement = gridRef.current.querySelector(".tui-grid");
            if (gridElement) {
                gridElement.style.backgroundColor = "#000000"; // Couleur de fond
                gridElement.style.border = "1px solid #ccc"; // Bordure
            }
        }
    }, [record]);
    var widgetList = useMemo(function () {
        return widgetModuleListFromLayout.map(function (widget) { return (_jsx("div", __assign({ className: "w-full rounded-[var(--border-widget)] mt-[var(--margin-mt-widget)] mr-[var(--margin-mr-widget)] mb-[var(--margin-mb-widget)] ml-[var(--margin-ml-widget)]" }, { children: _jsx(WidgetDisplay, { widget: widget }, widget.id) }))); });
    }, [widgetModuleListFromLayout]);
    return (_jsx(_Fragment, { children: module === "InboundEmail" ? (_jsx(InboundEmail, {})) : (_jsxs("div", __assign({ className: "w-full ".concat(isFocusMode && "h-full", " ") }, { children: [_jsxs("div", __assign({ className: "border-2 m-2 min-h-[600px] rounded-md bg-[#f4f4ff] dark:bg-[rgb(var(--color-gray-400))] ".concat(isFocusMode && "h-full") }, { children: [_jsxs("div", __assign({ className: "" }, { children: [_jsxs("div", __assign({ className: "flex border-b-2 dark:bg-[rgb(var(--color-gray-600))]" }, { children: [_jsx("div", __assign({ className: "flex flex-col justify-center items-center m-2" }, { children: _jsx("div", __assign({ className: "flex flex-row items-center justify-center space-x-2 text-[rgb(var(--color-gray-400))] font-medium" }, { children: _jsx(ViewManager, { module: module, config: config, initialConfigRef: initialConfigRef, onPageChange: setCurrentPage, onSetColumnsState: function (columns) {
                                                        return dispatch(setFieldState(columns));
                                                    }, onSetFiltersSelected: function (filters) {
                                                        return dispatch(setFiltersSelected(filters));
                                                    }, onSetFrozenFieldState: function (freezeColumns) {
                                                        return dispatch(setFrozenFieldState(freezeColumns));
                                                    }, 
                                                    /*onSetTotalFreezeRows={(moduleAndFreezeRows) =>
                                                  dispatch(setTotalFreezeRows(moduleAndFreezeRows))
                                                }*/
                                                    onSetElementCountPerPage: function (elementPerPage) {
                                                        return dispatch(setElementCountPerPage(elementPerPage));
                                                    } }) })) })), _jsxs("div", __assign({ className: "flex flex-row ml-auto p-2" }, { children: [_jsxs("div", __assign({ className: "relative m-2 flex items-center " }, { children: [_jsx(Switch, { checked: isFocusMode, onChange: handleModeScreen, slotProps: {
                                                                input: {
                                                                    "aria-label": "Focus Mode Toggle",
                                                                },
                                                            }, sx: {
                                                                "& .MuiSwitch-thumb": {
                                                                    backgroundColor: isFocusMode
                                                                        ? "var(--colors-switch-on-icon)"
                                                                        : "gray",
                                                                    transition: "background-color 0.5s",
                                                                },
                                                                "& .MuiSwitch-track": {
                                                                    backgroundColor: isFocusMode
                                                                        ? "var(--colors-switch-on-bg)"
                                                                        : "lightgray",
                                                                    transition: "background-color 0.5s",
                                                                },
                                                            } }), _jsx("p", __assign({ className: "text-sm text-gray-400 px-1" }, { children: isFocusMode
                                                                ? t("app.LBL_CONCENTATION_MODE")
                                                                : t("app.LBL_NORMAL_MODE") }))] })), _jsx("div", __assign({ className: "relative m-2" }, { children: _jsx(Input, { ref: inputRef, type: "text", placeholder: String(t("app.LBL_BASIC_SEARCH")), onChange: handleSearchSimple, className: "w-[180px]", variant: "plain", sx: { background: "white" }, endDecorator: _jsx(FontAwesomeIcon, { icon: faMagnifyingGlass, className: "absolute right-[10px] top-[12px] text-gray-400" }) }) })), _jsx("div", __assign({ className: "relative m-2" }, { children: _jsx(WidgetSelector, { widget: filter, onChange: onChange }) }))] }))] })), _jsx("div", __assign({ className: "flex  mt-5 px-5 text-sm text-[rgb(var(--color-gray-500))] relative" }, { children: widgetModuleListFromLayout.length > 0 && (_jsx("div", __assign({ className: "flex overflow-x-auto w-full relative widgets gap-3" }, { children: widgetList }))) }))] })), _jsxs("div", __assign({ className: "flex flex-row items-center p-2 ", ref: rowHeaderRef }, { children: [_jsx(Massupdate, { recordId: rowIdChecked, module: module, rowCheckedCount: rowChecked.length, selectedDesc: selectedDesc, isDeleted: handleFromMassupdate, isLoading: isLoadDelete, unCheck: handleUnCheckMassupdate, checkPage: handleCheckPageMassupdate, checkAll: handleCheckAllMassupdate, isChecked: isChecked, allRows: totalResultCount, rowsPerPage: data.length, massUpdateFields: massUpdateFields, isMassupdated: handleMassupdateConfirm, isLoadOnEditing: loadEditing }), _jsx("div", __assign({ className: "ml-auto" }, { children: _jsx(Pagination, { paginationVisible: elementCountPerPage === "infini" || totalResultCount === 0
                                            ? false
                                            : true, totalResult: totalResultCount, elementPerPage: elementPerPage, currentPage: currentPage, onChangePagination: function (event) { return changePagination(event); } }) })), _jsx("div", __assign({ className: "cursor-pointer mr-2", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                        var result;
                                        var _a, _b, _c;
                                        return __generator(this, function (_d) {
                                            switch (_d.label) {
                                                case 0:
                                                    dispatch(setWidgetDisplay(false));
                                                    if (!widgetDisplay) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, popup.showPopup({
                                                            type: "widget/managerField",
                                                            slot: Slot.DRAWER_SOUTH,
                                                            payload: {
                                                                module: (_a = widget.payload) === null || _a === void 0 ? void 0 : _a.module,
                                                                view_defs: (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.view_defs,
                                                                field_defs: (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.field_defs,
                                                                count: totalResultCount,
                                                                elementPerPage: elementCountPerPage,
                                                            },
                                                        })];
                                                case 1:
                                                    result = _d.sent();
                                                    _d.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); } }, { children: _jsx(FontAwesomeIcon, { icon: faColumns3, className: " text-gray-400 dark:text-[var(--colors-text-primary)]" }) }))] })), (isLoading || isLoad) && _jsx(LoaderImage, {}), _jsx("div", __assign({ id: "grid", className: "grid-container mb-3 ml-3 rounded-md" }, { children: upGrid && (_jsx("div", __assign({ className: "relative", style: { width: "100%" } }, { children: _jsx(Grid, { ref: tuiref, width: "auto", scrollX: true, scrollY: true, columns: tuiCols, data: tuiRecord, rowHeaders: [
                                        {
                                            type: "checkbox",
                                            header: "\n                    <label class=\"invisible\">\n                      <input ref=".concat(rowHeaderRef, " type=\"checkbox\" id=\"all-checkbox\" class=\"hidden-input\" name=\"_checked\"/>\n                      <span class=\"custom-input\"></span>\n                    </label>\n                  "),
                                        },
                                    ], pageOptions: {
                                        useClient: true,
                                        type: typePageOptions,
                                        perPage: perPage,
                                    }, bodyHeight: 590, rowHeight: "auto", columnOptions: {
                                        frozenCount: freezeColumns,
                                        resizable: true,
                                        minWidth: 180,
                                    }, showDummyRows: true, onCheck: function (e) {
                                        setRowChecked(function (prev) { return __spreadArray(__spreadArray([], prev, true), [e.rowKey], false); });
                                        setRowIdChecked(function (prev) { return __spreadArray(__spreadArray([], prev, true), [record[e.rowKey].id], false); });
                                        if (record.length === rowChecked.length + 1)
                                            setIsChecked(true);
                                    }, onUncheck: function (ev) {
                                        var rowKey = ev.rowKey;
                                        var id = record[rowKey].id;
                                        setRowChecked(function (prev) {
                                            return prev.filter(function (rowChecked) { return rowChecked !== rowKey; });
                                        });
                                        setRowIdChecked(function (prev) {
                                            return prev.filter(function (rowIdChecked) { return rowIdChecked !== id; });
                                        });
                                    } }, key) }))) }))] })), _jsx("div", { id: "portal", className: "fixed left-0 top-0 z-0" })] }))) }));
}
widgetsDictionary.register("widget/module/list", {
    name: "Module List",
    display: ModuleList,
    selectable: false,
});
